import { API_URL_V1, API_URL_V2 } from "../constants";

export const waitingList = `${API_URL_V1}/waiting-list/`;
export const eventsList = `${API_URL_V2}/events/`;
